module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/office-d58327314153bcbad67aa021d7f05b9b.jpg";